// eslint-disable-next-line no-shadow
export enum THEMES {
  LIGHT = 'LIGHT',
  ONE_DARK = 'ONE_DARK',
  INNOE = 'INNOE',
  INVERTI = 'INVERTI',
  OMNICOST = 'OMNICOST'
}
